// extracted by mini-css-extract-plugin
export var quantityInput = "_n1-0";